// ═══════════════════════════════════════════════════════════════════════════
// i18n-auto — Overlay de traductions AUTO-GÉNÉRÉES (FR → NL/EN/DE)
// ───────────────────────────────────────────────────────────────────────────
// Le cron `i18n-translate` (quotidien) traduit via Claude les textes FR encore
// non traduits (notamment les champs libres des barèmes : source, nom, label,
// description) et publie le résultat dans app_config.i18n_auto SANS redéploiement.
// Le layout charge /api/i18n-live au démarrage et appelle setAutoTranslations.
// tx() (lang-context) bascule sur cet overlay quand une string FR n'est PAS dans
// les dictionnaires écrits à la main → plus aucun texte FR figé pour un NL/EN/DE.
//
// Map = { [stringFR exacte]: { nl, en, de } }. Overlay vide par défaut →
// comportement identique à avant (repli FR). Zéro régression hors traduction.
// ═══════════════════════════════════════════════════════════════════════════
let _auto = {};

export function setAutoTranslations(map) {
  _auto = (map && typeof map === 'object') ? map : {};
}
export function getAutoTranslations() { return _auto; }

/** Traduction auto d'une string FR dans `lang`, ou null si absente. */
export function getAutoTranslation(frStr, lang) {
  if (!frStr || lang === 'fr') return null;
  const e = _auto[frStr];
  return (e && typeof e === 'object' && e[lang]) ? e[lang] : null;
}
